import React, { useContext } from 'react'
import { Button } from "@chakra-ui/react";
import { ChatIcon } from '@chakra-ui/icons';

import { feedbackContext } from '../contexts/FeedbackProvider';

export const FeedbackButton = (props) => {
    const { closeMenuDrawer } = props;

    const [feedbackModalIsOpen, feedbackModalOnOpen] = useContext(feedbackContext);

    const onClick = () => {
        feedbackModalOnOpen(true);
        closeMenuDrawer();
    };

    return (
        <Button
            rightIcon={<ChatIcon color='gray.600' boxSize={4} />}
            w='100%'
            onClick={onClick}
            fontWeight={400}
            size="lg"
            variant="tertiary"
            color='black'
            _hover={{backgroundColor: 'white', textColor: 'black'}}
            display='flex'
            justifyContent='space-between'
            height="auto"
            p={{
                base: 4,
                md: 3,
            }}
            lineHeight={1}
        >
            Provide Feedback
        </Button>
    );
};
